import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import ApiService from '../../services/ApiService';
import ListView from '../list/ListView';
import { getColumnDefs } from '../../util/grid';
import FileNotFound from '../FileNotFound';

const EquipmentInventory = () => {
  const [units, setUnits] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [message, setMessage] = useState('');
  const [layout, setLayout] = useState(null);

  const fetchUnits = () => {
    return ApiService.get('/crm/units?saleslist=true').then(response => {
      setUnits(_.get(response, 'data.list', []));
      setHeaders(_.get(response, 'data.headers'));
      setMessage(_.get(response, 'data.message'));
    });
  };

  const fetchGridLayout = () => {
    return ApiService.get('user-grid-layouts', { params: { pageName: 'EQS7' } }).then(({ data }) => {
      if (data && data.length) {
        setLayout(data[0].GridLayout);
      }
    });
  };

  useEffect(() => {
    fetchUnits();
    fetchGridLayout();
  }, []);

  if (!units.length || !headers.length) {
    if (message) {
      return <FileNotFound>{message}</FileNotFound>;
    }

    return null;
  }

  return (
    <ListView
      canAdd={false}
      showRowToolbar={false}
      columnDefs={getColumnDefs(headers, layout)}
      namespace="eqsinv"
      rowData={units}
      rowHeight={80}
      itemName="EQS7"
      layout={layout}
    />
  );
};

export default EquipmentInventory;
